import markerSDK from '@marker.io/browser';
import config from 'config';
const { key } = config;
export const widget = markerSDK.loadWidget({ destination: key.markerIoKey });
